import { createFileRoute } from '@tanstack/react-router';
import { MyPaymentsPage } from '../pages/MyPaymentsPage';
import { ProtectedRoute } from '../../../shared/ui';

const ProtectedMyPayments = () => (
  <ProtectedRoute>
    <MyPaymentsPage />
  </ProtectedRoute>
);

export const Route = createFileRoute('/payments')({
  component: ProtectedMyPayments,
});
